import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Toolbar,
  Hidden,
  List,
  ListItem,
  ListItemIcon,
  Popover,
  Typography,
  IconButton,
  Button,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MenuIcon from "@material-ui/icons/Menu";
import { Image, DarkModeToggler } from "@components/atoms";
import { Section } from "@components/organisms"

import main_icon from "@assets/images/main_icon.png";
import main_icon_negative from '@assets/images/main_icon_negative.png';

import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";

//redux functions
import { logout } from "@store/user";
import { setCountiesList } from "@store/counties";

//API Requests
import { ConnectService, CredentialsService } from "@services";

const useStyles = makeStyles((theme) => ({
  flexGrow: {
    flexGrow: 1,
  },
  navigationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    zIndex: 999,
    // maxWidth: theme.layout.contentWidth,
    width: "100%",
    margin: "0 auto",
    padding: theme.spacing(0, 2),
    // [theme.breakpoints.up("sm")]: {
    //   padding: theme.spacing(0, 8),
    // },
  },
  navLink: {
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
  listItem: {
    cursor: "pointer",
    "&:hover > .menu-item, &:hover svg": {
      color: theme.palette.primary.dark,
    },
    "&.menu-item--no-dropdown": {
      paddingRight: 0,
    },
  },
  listItemActive: {
    "&> .menu-item": {
      color: theme.palette.primary.dark,
    },
  },
  listItemText: {
    flex: "0 0 auto",
    marginRight: theme.spacing(2),
    whiteSpace: "nowrap",
  },
  listItemButton: {
    whiteSpace: "nowrap",
  },
  listItemIcon: {
    minWidth: "auto",
  },
  popover: {
    padding: theme.spacing(4),
    border: theme.spacing(2),
    boxShadow: "0 0.5rem 2rem 2px rgba(116, 123, 144, 0.09)",
    minWidth: 350,
    marginTop: theme.spacing(2),
  },
  iconButton: {
    // marginLeft: theme.spacing(2),
    // padding: 0,
    "&:hover": {
      background: "transparent",
    },
  },
  expandOpen: {
    transform: "rotate(180deg)",
    color: theme.palette.primary.dark,
  },
  logoContainer: {
    width: 130,
    height: 40,
    [theme.breakpoints.up("md")]: {
      width: 160,
      height: 50,
    },
  },
  logoContainerDark: {
    width: 130,
    height: 35,
    [theme.breakpoints.up("md")]: {
      width: 150,
      height: 40,
    },
  },
  logoImage: {
    width: "100%",
    height: "100%",
  },
  menu: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuItem: {
    marginRight: theme.spacing(5),
    "&:last-child": {
      marginRight: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  menuGroupTitle: {
    textTransform: "uppercase",
  },
  noUnderline: {
    textDecoration: 'none',
  },
  groupItems: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerText: {
    fontWeight: 550,
  },
  blueStripesGradient: {
    height: theme.spacing(1),
    color: "white",
    background:
      //"linear-gradient(90deg, rgba(79,154,201,1) 47%, rgba(11,82,125,1) 100%)",
      "#004987",
  },
}));

const Topbar = ({
  themeMode,
  themeToggler,
  onSidebarOpen,
  pages,
  className,
  ...rest
}) => {
  //create history
  const history = useHistory();
  //redux
  const dispatch = useDispatch();

  const classes = useStyles();

  const { user } = useSelector((state) => state.user);
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const open = Boolean(anchorEl);

  //onPageLoad
  React.useEffect(() => {
    setLoading(true);
    //sample api GET request
    // new api call, will switch to this later
    // CredentialsService.getCountiesList()
    // old api call
    ConnectService.getCountiesList()
      .then((data) => {
        setLoading(false);
        dispatch(setCountiesList(data.counties))
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const signOut = () => {
    dispatch(logout());
    history.push("/");
  };

  return (
    <>
    <div className={classes.blueStripesGradient} />
    <Toolbar disableGutters className={classes.toolbar} {...rest}>
      {/* <div className={classes.flexGrow} /> */}
      {/* <Hidden smDown>
        <List disablePadding className={classes.navigationContainer}>

          <ListItem className={clsx(classes.listItem)}>
            <Link to="/dashboard" className={classes.noUnderline}>
              <Typography
                color="textPrimary"
                className={clsx(classes.listItemText, "menu-item")}
              >
                Home
              </Typography>
            </Link>
          </ListItem> */}
          {/* <ListItem
            className={clsx(classes.listItem)}
          >
            <Link to="/account" className={classes.noUnderline}>
            <Typography
                color="textPrimary"
                className={clsx(classes.listItemText, "menu-item")}
              >
                Profile
              </Typography>
            </Link>
          </ListItem> */}
          {/* <ListItem
            // className={clsx(classes.listItem)}
          >
            <DarkModeToggler
              themeMode={themeMode}
              onClick={() => themeToggler()}
            />
          </ListItem> */}
          {/* <ListItem className={clsx(classes.listItem, 'menu-item--no-dropdown')}>
            <Button
              variant="outlined"
              component="a"
              href="/documentation"
            >
              Documentation
            </Button>
          </ListItem> */}
          {/* <ListItem className={clsx(classes.listItem, 'menu-item--no-dropdown')}>
            <Button
              variant="contained"
              color="primary"
              component="a"
              target="blank"
              href="https://material-ui.com/store/items/the-front-landing-page/"
              className={classes.listItemButton}
            >
              Buy Now
            </Button>
          </ListItem> */}
        {/* </List>
      </Hidden> */}
      {/* <Hidden mdUp> */}
        {/* <DarkModeToggler themeMode={themeMode} onClick={() => themeToggler()} /> */}
        <div className={classes.groupItems}>
        <IconButton
          className={classes.iconButton}
          onClick={onSidebarOpen}
          aria-label="Menu"
        >
          <MenuIcon />
        </IconButton>
      {/* </Hidden> */}
      {auth && (
        <>
          <IconButton
            className={classes.iconButton}
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            {/* <AccountCircle /> */}
          </IconButton>
          <Hidden smDown>
            <Typography variant="h6" className={classes.headerText}>
              Hello, {user.firstName} {user.lastName}
            </Typography>
          </Hidden>
          {/* <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={open}
            onClose={handleClose}
          >
            <MenuItem>
              <Link to="/account" className={classes.noUnderline}>
                <Typography
                  color="textPrimary"
                  className={clsx(classes.listItemText, "menu-item")}
                >
                  Profile
                </Typography>
              </Link>
            </MenuItem>
            <MenuItem onClick={signOut}></MenuItem>
          </Menu> */}
        </>
      )}
      </div>
      <div className={themeMode === "light" ? classes.logoContainer : classes.logoContainerDark}>
        <a href="/" title="thefront">
          <Image
            className={classes.logoImage}
            src={themeMode === "light" ? main_icon : main_icon_negative}
            lazy={false}
          />
        </a>
      </div>
    </Toolbar>
    </>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
  pages: PropTypes.object.isRequired,
  themeToggler: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
};

export default Topbar;
